import { getApiError } from "@/lib/api/errors";

export const NETWORK_ERROR_MESSAGE = "Can't reach the server. Try again.";
export const RATE_LIMIT_MESSAGE =
  "Too many requests. Try again in a few minutes.";

interface ResolveOptions {
  byStatus?: Record<number, string>;
  fallback: string;
}

export function resolveApiErrorMessage(
  error: unknown,
  { byStatus = {}, fallback }: ResolveOptions
): string {
  const { status, isNetworkError } = getApiError(error);
  if (status !== undefined && byStatus[status] !== undefined) {
    return byStatus[status];
  }
  if (isNetworkError) return NETWORK_ERROR_MESSAGE;
  if (status === 429) return RATE_LIMIT_MESSAGE;
  return fallback;
}
